import {
  ThemeTogglerWrapper,
  ThemeToggleThumb,
  ThemeControlsWrapper,
  ThemeRadioGroup,
  ThemeRadioButton,
  Radio,
} from '../styles.ts';
import {useEffect} from 'react';
import {applyTheme, useThemeStore} from 'entities/theme';
import {TTheme} from 'entities/theme/model/store.ts';

const getPosition = (theme: TTheme) => {
  switch (theme) {
    case 'light':
      return 0;
    // return -8;
    case 'dark':
      return 78;
    // return 66;
    // case 'system':
    //   return 151;
    default:
      return 0;
  }
};

const getScale = (theme: TTheme) => {
  switch (theme) {
    case 'light':
      return 1;
    // return 0.85;
    case 'dark':
      return 0.82;
    // return 0.82;
    // case 'system':
    //   return 0.96;
    default:
      return 1;
  }
};

const THEMES: Record<TTheme, string> = {
  light: 'Светлая',
  dark: 'Темная',
  // system: 'Системная',
} as const;

type ThemeControllerProps = {controllerType: 'toggler' | 'radio'};

export const ThemeController = ({controllerType}: ThemeControllerProps) => {
  const {theme, switchTheme} = useThemeStore((state) => state);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  if (controllerType === 'toggler')
    return (
      <ThemeTogglerWrapper>
        <ThemeToggleThumb $position={getPosition(theme)} $scale={getScale(theme)} />
        <ThemeControlsWrapper>
          {Object.entries(THEMES).map(([theme, label]: [string, string]) => (
            <button onClick={() => switchTheme(theme as TTheme)}>{label}</button>
          ))}
        </ThemeControlsWrapper>
      </ThemeTogglerWrapper>
    );

  return (
    <ThemeRadioGroup>
      {Object.entries(THEMES).map(([themeCode, label]: [string, string]) => (
        <ThemeRadioButton onClick={() => switchTheme(themeCode as TTheme)}>
          {label}
          <Radio $active={theme === themeCode} />
        </ThemeRadioButton>
      ))}
    </ThemeRadioGroup>
  );
};
